import React from "react";
import useFetch from "../../../utils/hooks/useFetch";
import { reportEndpoints } from "../../../api/endpoints/report.endpoints";
import { Link } from "react-router-dom";
import { convertDateToDDMMYYYY } from "../../../utils/dateFunctions";

const Vetted = ({ search }) => {
  const {
    data: vettedReports,
    loading: loadingVettedReports,
    error: vettedReportsErr,
  } = useFetch(reportEndpoints.getReports, {
    status: "vetted",
  });

  const headings = ["Report Name", "Submitted Date", "Status", "Actions"];

  const filteredReports = vettedReports?.reports?.filter((item) =>
    item?.name?.toLowerCase()?.includes(search?.toLowerCase())
  );

  const vettingStatus = {
    vetted: "Verified",
  };

  const hasSearchQuery = Boolean(search?.trim());
  const emptyMessage = hasSearchQuery
    ? "No vetted reports match your search."
    : "No vetted reports yet.";

  return (
    <div className="reports-table-container">
      <div className="reports-table">
        <div className="reports-table-row reports-table-header">
          {headings.map((item) => (
            <div key={item} className="reports-table-cell">
              {item}
            </div>
          ))}
        </div>
        {loadingVettedReports ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              Loading vetted reports...
            </div>
          </div>
        ) : vettedReportsErr ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              Unable to load vetted reports right now.
            </div>
          </div>
        ) : (filteredReports?.length || 0) === 0 ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              {emptyMessage}
            </div>
          </div>
        ) : (
          filteredReports.map((item) => (
            <div key={item?.id} className="reports-table-row">
              <div className="reports-table-cell">{item?.name}</div>
              <div className="reports-table-cell">
                {convertDateToDDMMYYYY(item?.updatedAt)}
              </div>
              <div
                className={`reports-table-cell ${
                  item?.status !== "Verified"
                    ? "report-verified"
                    : "report-unverified"
                }`}
              >
                {vettingStatus[item?.status]}
              </div>
              <div className="reports-table-cell ">
                <Link to={`/score-card/${item?.id}`}>
                  <button className="report-actions-btn">Preview</button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Vetted;
